<template>
  <div class="collapsible">
      <div class="collapsible__header"
           @click.stop="toggleCollapsedStatus()">
        <span class="collapsible__header-title" v-html="title"></span>
        <div :style="headerAdditionalStyles" class="collapsible__header-slot-wrapper">
          <slot name="header-additional"></slot>
        </div>
        <slot name="date-picker"></slot>
        <slot name="button"></slot>
        <div class="collapsible__arrow" v-if="!isStaticView && !disableCollapsing"
             :class="{'collapsible__arrow_expanded': (maxHeight && isCollapsedComputed) || (!maxHeight && !isCollapsedComputed)}">
        </div>
      </div>
      <div>
        <div v-show="!isCollapsedComputed || disableCollapsing || isStaticView || maxHeight"
             :style="{ maxHeight: maxHeightComputed }"
             class="collapsible__content"
             :class="{'collapsible__content-hide-divider': isDividerHidden}">
          <slot></slot>
        </div>
      </div>
  </div>
</template>

<script>
/**
 * collapsible content wrapper
 */
export default {
  name: 'BaseCollapsibleBlock',
  model: {
    prop: 'isCollapsedLocal',
    event: 'change'
  },
  props: {
    isCollapsedLocal: { default: true },
    isCollapsed: { type: Boolean, default: true },
    // for pdf mode
    isStaticView: { type: Boolean, default: false },
    isDividerHidden: { type: Boolean, default: false },
    disableCollapsing: { type: Boolean, default: false },
    title: { type: String, required: true },
    maxHeight: { type: String, default: '' },
    headerAdditionalStyles: { type: Object, default: () => ({}) }
  },
  computed: {
    isCollapsedComputed: function () {
      if (this.isCollapsed) {
        return this.isCollapsedLocal
      }
      return !this.isCollapsedLocal
    },
    maxHeightComputed () {
      return (this.maxHeight && this.isCollapsedComputed) || !this.maxHeight ? 'none' : this.maxHeight
    }
  },
  methods: {
    toggleCollapsedStatus () {
      if (this.isStaticView || this.disableCollapsing) {
        return
      }
      this.isCollapsedLocal = !this.isCollapsedLocal
      this.$emit('collapsed', this.isCollapsedLocal)
      this.$emit('change', this.isCollapsedLocal)
    }
  }
}
</script>

<style scoped lang="scss">

  .collapsible {
    break-inside: avoid;
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: white;
    margin-top: 1rem;
    border-radius: 4px;
    border: 1px solid rgba(1, 22, 39, 0.1);
    box-sizing: border-box;
    position: relative;

    &__header {
      display: flex;
      width: 100%;
      padding: 0 50px 0 24px;
      box-sizing: border-box;
      justify-content: space-between;
      height: 60px;
      align-items: center;
      user-select: none;
      position: relative;
      cursor: pointer;

      &-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.67;
        color: $rfx-dark-march;
        @include ellipsis;
      }

      &-slot-wrapper {
        display: flex;
        margin-left: 10px;
        align-items: center;
        flex: 1 1;
        overflow: hidden;
      }

      &-comments-number {
        margin-left: 20px;
      }

    }

    &__content {
      border-top: 1px solid $rfx-light-grey;
      position: relative;

      &-hide-divider {
        border: none;
      }
    }

    &__arrow {
      position: absolute;
      top: 26px;
      right: 26px;
      width: 12px;
      height: 12px;
      border-left: 2px solid $rfx-dark-march;
      border-bottom: 2px solid $rfx-dark-march;
      transform: translate(5px, -2px) rotate(-45deg);

      &_expanded {
        transform: translate(5px, 2px) rotate(135deg);
      }
    }
  }

</style>
